export const SMS_AND_BANKID = 'sms_and_bankid'
export const BANKID = 'bankId'
export const SMS = 'sms'
